// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===== Documents Page - Mobile First Design ===== */

* {
  box-sizing: border-box;
}

.documents-page {
  padding: 12px;
  max-width: 100%;
  margin: 0 auto;
  min-height: 100vh;
  background: #f5f5f5;
  font-family:
    -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue",
    Arial, sans-serif;
}

/* ===== Header ===== */
.documents-header {
  margin-bottom: 16px;
  text-align: center;
  padding: 0 4px;
}

.header-info h1 {
  margin: 0 0 6px 0;
  color: #212529;
  font-size: 18px;
  font-weight: 600;
  line-height: 1.3;
  word-break: break-word;
}

.document-count {
  margin: 0;
  color: #6c757d;
  font-size: 13px;
}

/* ===== Loading State ===== */
.loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 50vh;
  text-align: center;
}

.spinner {
  width: 36px;
  height: 36px;
  border: 3px solid #e9ecef;
  border-top: 3px solid #f97316;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
  margin-bottom: 16px;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.loading p {
  color: #6c757d;
  font-size: 14px;
  margin: 0;
}

/* ===== Error State ===== */
.error-message {
  text-align: center;
  padding: 40px 20px;
  color: #dc3545;
  background: #fff;
  border-radius: 12px;
  font-size: 15px;
}

/* ===== Content Container ===== */
.documents-content {
  background: transparent;
}

.no-documents {
  text-align: center;
  padding: 40px 20px;
  color: #6c757d;
  background: #fff;
  border-radius: 12px;
  font-size: 15px;
}

/* ===== Documents Sections ===== */
.documents-sections {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.documents-category {
  background: transparent;
}

.category-title {
  font-size: 14px;
  font-weight: 600;
  color: #6c757d;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin: 0 0 12px 4px;
  padding-bottom: 8px;
  border-bottom: 1px solid #e9ecef;
}

/* ===== Documents List ===== */
.documents-grid {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

/* ===== Document Card ===== */
.document-card {
  background: #fff;
  border-radius: 10px;
  padding: 14px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);
  display: flex;
  align-items: center;
  gap: 12px;
  border: 1px solid #e9ecef;
  transition: all 0.2s ease;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}

.document-card:active {
  transform: scale(0.995);
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.04);
}

.commande-document {
  border-left: 3px solid #f97316;
  background: linear-gradient(to right, rgba(218, 112, 39, 0.03), #fff);
}

/* ===== Document Icon ===== */
.document-icon {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f8f9fa;
  border-radius: 8px;
  flex-shrink: 0;
  color: #495057;
}

.commande-document .document-icon {
  background: rgba(218, 112, 39, 0.1);
  color: #f97316;
}

/* ===== Document Info ===== */
.document-info {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.document-name {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: #212529;
  line-height: 1.3;
}

.document-filename {
  margin: 0;
  font-size: 12px;
  color: #6c757d;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.document-size {
  font-size: 11px;
  color: #adb5bd;
}

/* ===== Download Icon ===== */
.document-download-icon {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #adb5bd;
  flex-shrink: 0;
  transition: color 0.2s ease;
}

.document-card:hover .document-download-icon {
  color: #f97316;
}

/* ===== Hover Effects (Desktop) ===== */
@media (hover: hover) {
  .document-card:hover {
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
    border-color: #dee2e6;
  }
}

/* ===== Tablet ===== */
@media (min-width: 500px) {
  .documents-page {
    padding: 16px;
    max-width: 600px;
  }

  .documents-header {
    margin-bottom: 20px;
  }

  .header-info h1 {
    font-size: 20px;
  }

  .documents-grid {
    gap: 12px;
  }

  .document-card {
    padding: 16px;
  }

  .document-name {
    font-size: 15px;
  }

  .category-title {
    font-size: 14px;
    margin-bottom: 14px;
  }
}

/* ===== Desktop ===== */
@media (min-width: 768px) {
  .documents-page {
    padding: 24px;
    max-width: 700px;
  }

  .header-info h1 {
    font-size: 22px;
  }

  /* .document-card {
    padding: 18px 20px;
  } */

  .document-icon {
    width: 44px;
    height: 44px;
  }

  .document-download-icon {
    width: 40px;
    height: 40px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Documents/Documents.css"],"names":[],"mappings":"AAAA,qDAAqD;;AAErD;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB;;qBAEmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,cAAc;EACd,eAAe;EACf,SAAS;AACX;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA,kCAAkC;AAClC;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,8BAA8B;AAC9B;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,yCAAyC;EACzC,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,yBAAyB;EACzB,yBAAyB;EACzB,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,uBAAuB;EACvB,yCAAyC;AAC3C;;AAEA;EACE,8BAA8B;EAC9B,qEAAqE;AACvE;;AAEA,8BAA8B;AAC9B;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA,8BAA8B;AAC9B;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,8BAA8B;AAC9B;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA,wCAAwC;AACxC;EACE;IACE,yCAAyC;IACzC,qBAAqB;EACvB;AACF;;AAEA,uBAAuB;AACvB;EACE;IACE,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;AACF;;AAEA,wBAAwB;AACxB;EACE;IACE,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;;KAEG;;EAEH;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF","sourcesContent":["/* ===== Documents Page - Mobile First Design ===== */\n\n* {\n  box-sizing: border-box;\n}\n\n.documents-page {\n  padding: 12px;\n  max-width: 100%;\n  margin: 0 auto;\n  min-height: 100vh;\n  background: #f5f5f5;\n  font-family:\n    -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\",\n    Arial, sans-serif;\n}\n\n/* ===== Header ===== */\n.documents-header {\n  margin-bottom: 16px;\n  text-align: center;\n  padding: 0 4px;\n}\n\n.header-info h1 {\n  margin: 0 0 6px 0;\n  color: #212529;\n  font-size: 18px;\n  font-weight: 600;\n  line-height: 1.3;\n  word-break: break-word;\n}\n\n.document-count {\n  margin: 0;\n  color: #6c757d;\n  font-size: 13px;\n}\n\n/* ===== Loading State ===== */\n.loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 50vh;\n  text-align: center;\n}\n\n.spinner {\n  width: 36px;\n  height: 36px;\n  border: 3px solid #e9ecef;\n  border-top: 3px solid #f97316;\n  border-radius: 50%;\n  animation: spin 0.8s linear infinite;\n  margin-bottom: 16px;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.loading p {\n  color: #6c757d;\n  font-size: 14px;\n  margin: 0;\n}\n\n/* ===== Error State ===== */\n.error-message {\n  text-align: center;\n  padding: 40px 20px;\n  color: #dc3545;\n  background: #fff;\n  border-radius: 12px;\n  font-size: 15px;\n}\n\n/* ===== Content Container ===== */\n.documents-content {\n  background: transparent;\n}\n\n.no-documents {\n  text-align: center;\n  padding: 40px 20px;\n  color: #6c757d;\n  background: #fff;\n  border-radius: 12px;\n  font-size: 15px;\n}\n\n/* ===== Documents Sections ===== */\n.documents-sections {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.documents-category {\n  background: transparent;\n}\n\n.category-title {\n  font-size: 14px;\n  font-weight: 600;\n  color: #6c757d;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  margin: 0 0 12px 4px;\n  padding-bottom: 8px;\n  border-bottom: 1px solid #e9ecef;\n}\n\n/* ===== Documents List ===== */\n.documents-grid {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n/* ===== Document Card ===== */\n.document-card {\n  background: #fff;\n  border-radius: 10px;\n  padding: 14px;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  border: 1px solid #e9ecef;\n  transition: all 0.2s ease;\n  cursor: pointer;\n  -webkit-tap-highlight-color: transparent;\n}\n\n.document-card:active {\n  transform: scale(0.995);\n  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.04);\n}\n\n.commande-document {\n  border-left: 3px solid #f97316;\n  background: linear-gradient(to right, rgba(218, 112, 39, 0.03), #fff);\n}\n\n/* ===== Document Icon ===== */\n.document-icon {\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #f8f9fa;\n  border-radius: 8px;\n  flex-shrink: 0;\n  color: #495057;\n}\n\n.commande-document .document-icon {\n  background: rgba(218, 112, 39, 0.1);\n  color: #f97316;\n}\n\n/* ===== Document Info ===== */\n.document-info {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.document-name {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 600;\n  color: #212529;\n  line-height: 1.3;\n}\n\n.document-filename {\n  margin: 0;\n  font-size: 12px;\n  color: #6c757d;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.document-size {\n  font-size: 11px;\n  color: #adb5bd;\n}\n\n/* ===== Download Icon ===== */\n.document-download-icon {\n  width: 36px;\n  height: 36px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #adb5bd;\n  flex-shrink: 0;\n  transition: color 0.2s ease;\n}\n\n.document-card:hover .document-download-icon {\n  color: #f97316;\n}\n\n/* ===== Hover Effects (Desktop) ===== */\n@media (hover: hover) {\n  .document-card:hover {\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);\n    border-color: #dee2e6;\n  }\n}\n\n/* ===== Tablet ===== */\n@media (min-width: 500px) {\n  .documents-page {\n    padding: 16px;\n    max-width: 600px;\n  }\n\n  .documents-header {\n    margin-bottom: 20px;\n  }\n\n  .header-info h1 {\n    font-size: 20px;\n  }\n\n  .documents-grid {\n    gap: 12px;\n  }\n\n  .document-card {\n    padding: 16px;\n  }\n\n  .document-name {\n    font-size: 15px;\n  }\n\n  .category-title {\n    font-size: 14px;\n    margin-bottom: 14px;\n  }\n}\n\n/* ===== Desktop ===== */\n@media (min-width: 768px) {\n  .documents-page {\n    padding: 24px;\n    max-width: 700px;\n  }\n\n  .header-info h1 {\n    font-size: 22px;\n  }\n\n  /* .document-card {\n    padding: 18px 20px;\n  } */\n\n  .document-icon {\n    width: 44px;\n    height: 44px;\n  }\n\n  .document-download-icon {\n    width: 40px;\n    height: 40px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
